import { NgModule } from '@angular/core';
import { TicketsComponent } from './tickets.component';
import { TicketTypeComponent } from './ticket-type/ticket-type.component';
import { PropertiesComponent } from './properties/properties.component';
import { AnswerTemplateComponent } from './answertemplate/answer-template.component';
import { PriorityComponent } from './priority/priority.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/primeng';
import { Select2Module } from 'ng2-select2';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { ServicesComponent } from './service/service.component';
import { ComponentsModule } from '../../../../../components/component.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    PaginatorModule,
    Select2Module,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ComponentsModule,
    RouterModule,
  ],
  declarations: [
    TicketsComponent,
    TicketTypeComponent,
    PropertiesComponent,
    AnswerTemplateComponent,
    PriorityComponent,
    ServicesComponent,
  ],
  exports: [
    TicketsComponent,
    TicketTypeComponent,
    PropertiesComponent,
    AnswerTemplateComponent,
    PriorityComponent,
    ServicesComponent,
  ],
  providers: [],
})
export class TicketsModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/tickets.module.ts